interface CommonConfig {
  VITE_APP_DEMO_CONNECTIONS: string[];
}

interface ScenarioConfig {
  VITE_APP_KEYCLOAK_URL: string;
  VITE_APP_KEYCLOAK_REALM: string;
  VITE_APP_KEYCLOAK_REALM_CLIENT_ID: string;
  VITE_APP_API_BASE_URL: string;
  VITE_APP_FERROUS_API_BASE_URL: string;
  VITE_APP_UI_BASE_URL: string;
  VITE_APP_SMALL_LOGO: string;
  VITE_APP_BIG_LOGO: string;
  VITE_APP_CHAT_LOGO: string;
  VITE_APP_SIDEBAR_LOGO: string;
  VITE_APP_DEMO_CONNECTIONS?: string[];
  VITE_APP_PRODUCT_FRUITS_KEY?: string;
}

interface ScenarioConfigs {
  [scenario: string]: ScenarioConfig;
}

const commonConfig: CommonConfig = {
  VITE_APP_DEMO_CONNECTIONS: [
    "2c8538c7-da3f-4339-a749-c47a7e88b18d",
    "b52a969f-3774-49a9-b81b-80f1861063d5",
  ],
};

const scenarioConfigs: ScenarioConfigs = {
  prod: {
    VITE_APP_KEYCLOAK_URL: "https://auth.getcrux.ai/auth/",
    VITE_APP_KEYCLOAK_REALM: "crux",
    VITE_APP_KEYCLOAK_REALM_CLIENT_ID: "react-auth",
    VITE_APP_API_BASE_URL: "https://api.getcrux.ai/api",
    VITE_APP_FERROUS_API_BASE_URL: "https://ferrous.api.getcrux.ai/api",
    // VITE_APP_API_BASE_URL: "http://127.0.0.1:8000/api",
    VITE_APP_UI_BASE_URL: "https://app.getcrux.ai/",
    VITE_APP_SMALL_LOGO: import.meta.env.VITE_APP_SMALL_LOGO as string,
    VITE_APP_BIG_LOGO: import.meta.env.VITE_APP_BIG_LOGO as string,
    VITE_APP_CHAT_LOGO: import.meta.env.VITE_APP_CHAT_LOGO as string,
    VITE_APP_SIDEBAR_LOGO: import.meta.env.VITE_APP_SIDEBAR_LOGO as string,
  },
  beta: {
    VITE_APP_KEYCLOAK_URL: "https://idp.getcrux.ai/auth/",
    VITE_APP_KEYCLOAK_REALM: "crux",
    VITE_APP_KEYCLOAK_REALM_CLIENT_ID: "react-auth",
    VITE_APP_API_BASE_URL: "https://api.getcrux.ai/api",
    // VITE_APP_API_BASE_URL:'http://127.0.0.1:8000/api',
    VITE_APP_FERROUS_API_BASE_URL: "https://beta.insights.api.getcrux.ai/api",
    VITE_APP_UI_BASE_URL: "https://dev.app.getcrux.ai",
    VITE_APP_SMALL_LOGO: import.meta.env.VITE_APP_SMALL_LOGO as string,
    VITE_APP_BIG_LOGO: import.meta.env.VITE_APP_BIG_LOGO as string,
    VITE_APP_CHAT_LOGO: import.meta.env.VITE_APP_CHAT_LOGO as string,
    VITE_APP_SIDEBAR_LOGO: import.meta.env.VITE_APP_SIDEBAR_LOGO as string,
  },
  uat: {
    VITE_APP_KEYCLOAK_URL: "https://auth.getcrux.ai/auth/",
    VITE_APP_KEYCLOAK_REALM: "crux",
    VITE_APP_KEYCLOAK_REALM_CLIENT_ID: "react-auth",
    VITE_APP_API_BASE_URL: "https://uat.api.getcrux.ai/api",
    // VITE_APP_API_BASE_URL:'http://127.0.0.1:8000/api',
    VITE_APP_FERROUS_API_BASE_URL: "https://uat.ferrous.api.getcrux.ai/api",
    // VITE_APP_FERROUS_API_BASE_URL: "http://127.0.0.1:8000/api",
    VITE_APP_UI_BASE_URL: "https://uat.app.getcrux.ai",
    VITE_APP_SMALL_LOGO: import.meta.env.VITE_APP_SMALL_LOGO as string,
    VITE_APP_BIG_LOGO: import.meta.env.VITE_APP_BIG_LOGO as string,
    VITE_APP_CHAT_LOGO: import.meta.env.VITE_APP_CHAT_LOGO as string,
    VITE_APP_SIDEBAR_LOGO: import.meta.env.VITE_APP_SIDEBAR_LOGO as string,
  },
  qa: {
    VITE_APP_KEYCLOAK_URL: "https://auth.getcrux.ai/auth/",
    VITE_APP_KEYCLOAK_REALM: "crux",
    VITE_APP_KEYCLOAK_REALM_CLIENT_ID: "react-auth",
    // VITE_APP_API_BASE_URL: "http://127.0.0.1:8000/api",
    VITE_APP_API_BASE_URL: "https://qa.api.getcrux.ai/api",
    VITE_APP_FERROUS_API_BASE_URL: "https://qa.ferrous.api.getcrux.ai/api",
    VITE_APP_UI_BASE_URL: "https://qa.app.getcrux.ai",
    VITE_APP_SMALL_LOGO: import.meta.env.VITE_APP_SMALL_LOGO as string,
    VITE_APP_BIG_LOGO: import.meta.env.VITE_APP_BIG_LOGO as string,
    VITE_APP_CHAT_LOGO: import.meta.env.VITE_APP_CHAT_LOGO as string,
    VITE_APP_SIDEBAR_LOGO: import.meta.env.VITE_APP_SIDEBAR_LOGO as string,
    VITE_APP_PRODUCT_FRUITS_KEY: "nRiHDbgC7tKEV1e3",
  },
  dev: {
    VITE_APP_KEYCLOAK_URL: "https://auth.getcrux.ai/auth/",
    VITE_APP_KEYCLOAK_REALM: "crux",
    VITE_APP_KEYCLOAK_REALM_CLIENT_ID: "react-auth",
    VITE_APP_API_BASE_URL: "https://uat.api.getcrux.ai/api",
    // VITE_APP_API_BASE_URL:'http://127.0.0.1:8000/api',
    VITE_APP_FERROUS_API_BASE_URL: "https://dev-gcp-ferrous-api.getcrux.ai/api",
    // VITE_APP_FERROUS_API_BASE_URL: "http://127.0.0.1:8000/api",
    VITE_APP_UI_BASE_URL: "https://dev.app.getcrux.ai",
    VITE_APP_SMALL_LOGO: import.meta.env.VITE_APP_SMALL_LOGO as string,
    VITE_APP_BIG_LOGO: import.meta.env.VITE_APP_BIG_LOGO as string,
    VITE_APP_CHAT_LOGO: import.meta.env.VITE_APP_CHAT_LOGO as string,
    VITE_APP_SIDEBAR_LOGO: import.meta.env.VITE_APP_SIDEBAR_LOGO as string,
  },
};

export function getConfig(scenario: string): CommonConfig & ScenarioConfig {
  const scenarioConfig = scenarioConfigs[scenario] || {};
  return { ...commonConfig, ...scenarioConfig };
}
